// @flow
import React  from "react";
import { connect } from "react-redux";
import cx from "classnames";
import glamorous from "glamorous";
import { createStructuredSelector } from "reselect";
import t from "common/i18n";
import LinkButton from "root/components/LinkButton/LinkButton";
import SvgIcon from "root/components/SvgIcon";
import WithIndicator from "root/components/withIndicator";
import {
	selectSort,
	selectMediaType,
	selectFiltersPanelOpen,
	selectFilters,
	selectCategories, selectFiltersChanged,
} from "../../selectors";
import consts from "../../data/consts";
import bindActions, { types as ats } from "../../actions";
import type { Filters } from "../../data/types";
import SortBy from "./SortBy";
import VideoDuration from "./VideoDuration";
import VideoResolution from "./VideoResolution";
import NumberOfPeople from "./NumberOfPeople";
import Gender from "./Gender";
import Orientation from "./Orientation";
import Color from "./Color";
import MoreFilters from "./MoreFilters";

import SVG_ICONS from "~/assets/icons/icons";

import "./Filters.scss";

type OwnProps = {|
    doSearch: Function,
|};

type Props = {
    ...OwnProps,
    isOpen: boolean,
    mediaType: string,
    sort: string,
    categories: Array<{ label: string, value: string }>,
    filters: Filters,
    didFiltersChange: boolean,
    actions: { [string]: Function },
};

const GHeaderContent = glamorous.div(cx(
	"panel-header-container",
	"flex justify-content-between",
	"w-100",
	"mr3",
	"b--solid bc-window-border bw1 br-0 bt-0 bl-0 bb-1",
));

const GClearButton = glamorous(LinkButton)({
	paddingRight: "8px",
});

const borderBottom = "bw1 bt-0 bl-0 br-0 b--solid bc-window-border";

export const FiltersPanel = (props: Props) => {
	const { mediaType, filters } = props;

	const setSort = (option: {value: string}) => {
		props.actions[ats.SET_SEARCH_PARAMS]({ sort: option.value });
	};

	const doSearch = (data) => {
		props.doSearch({ filters: data });
	};

	const clearSearchFilters = () => {
		props.actions[ats.CLEAR_SEARCH_FILTERS]();
	};

	return (<div
		className={cx("shutterstock-filters-panel flex-shrink-0 overflow-x-hidden bg-window h-100 w-100")}>

		<GHeaderContent>
			<div className="flex align-items-center h-100">
				<WithIndicator className="mr3 flex align-items-center" showIndicator={props.didFiltersChange} >
					<SvgIcon size="sm" path={SVG_ICONS.SLIDERS} colorName="menu-icons" />
				</WithIndicator>
				<div className="f6 box-sm">{t("shutterstock.toggle_filters_button")}</div>
			</div>

			{props.didFiltersChange && <GClearButton dataTest="shutterstock-filters-clear-button"
				text={t("shutterstock.filters.clear")}
				fontSize={12}
				onClick={clearSearchFilters}/>}
		</GHeaderContent>

		<SortBy className={borderBottom} value={props.sort} setSort={setSort}/>

		{mediaType === consts.MEDIA_TYPES.VIDEOS && (
			<>
				<VideoDuration className={borderBottom}
					value={filters.duration}
					onChange={doSearch}/>
				<VideoResolution value={filters.resolution} onChange={doSearch}/>
			</>)}

		<NumberOfPeople className={borderBottom}
			mediaType={mediaType}
			withPeopleOnly={filters.withPeopleOnly}
			value={filters.numberOfPeople}
			onChange={doSearch}/>

		<Gender className={borderBottom}
			withPeopleOnly={filters.withPeopleOnly}
			value={filters.gender}
			onChange={doSearch}/>

		{mediaType === consts.MEDIA_TYPES.IMAGES && (
			<>
				<Orientation className={borderBottom}
					value={filters.orientation}
					onChange={doSearch}/>
				<Color className={borderBottom}
					value={filters.color}
					onChange={doSearch}/>
			</>)}

		<MoreFilters filters={filters}
			mediaType={mediaType}
			categories={props.categories}
			onChange={doSearch} />
	</div>);
};


export default connect<Props, OwnProps, _, _, _, _>(
	createStructuredSelector({
		mediaType: selectMediaType,
		isOpen: selectFiltersPanelOpen,
		sort: selectSort,
		filters: selectFilters,
		categories: selectCategories,
		didFiltersChange: selectFiltersChanged,
	}),
	(dispatch: Function) => ({
		actions: bindActions(dispatch),
	}),
)(FiltersPanel);
